import { useDhamLang } from '../../context/ManaunaDhamLangContext'
import { Instagram, Hash, Users, ExternalLink } from 'lucide-react'

const communities = [
  {
    tag: '#manonadham',
    url: 'https://www.instagram.com/explore/tags/manonadham/',
    posts: '5K+',
    color: 'from-pink-500 to-rose-600',
    bgLight: 'bg-pink-50',
    borderColor: 'border-pink-200',
    textColor: 'text-pink-700',
  },
  {
    tag: '#manaunadham',
    url: 'https://www.instagram.com/explore/tags/manaunadham/',
    posts: '3K+',
    color: 'from-purple-500 to-violet-600',
    bgLight: 'bg-purple-50',
    borderColor: 'border-purple-200',
    textColor: 'text-purple-700',
  },
  {
    tag: '#khatushyamji',
    url: 'https://www.instagram.com/explore/tags/khatushyamji/',
    posts: '1M+',
    color: 'from-amber-500 to-orange-600',
    bgLight: 'bg-amber-50',
    borderColor: 'border-amber-200',
    textColor: 'text-amber-700',
  },
]

export default function SocialSection() {
  const { t } = useDhamLang()

  return (
    <section className="py-16 lg:py-20 bg-gradient-to-br from-secondary-50 via-white to-primary-50/30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 rounded-full bg-pink-100 px-4 py-1.5 text-sm font-semibold text-pink-700 mb-4">
            <Users className="h-4 w-4" />
            {t({
              en: 'Community',
              hi: 'समुदाय',
              hinglish: 'Community',
            })}
          </div>
          <h2 className="text-3xl sm:text-4xl font-bold text-secondary-900">
            {t({
              en: 'Our Rising Community',
              hi: 'हमारा बढ़ता समुदाय',
              hinglish: 'Hamara Badhta Community',
            })}
          </h2>
          <p className="mt-3 text-secondary-600 max-w-lg mx-auto">
            {t({
              en: 'Join thousands of devotees sharing their Manauna Dham experiences on social media',
              hi: 'हज़ारों भक्तों से जुड़ें जो सोशल मीडिया पर अपने मनौना धाम अनुभव साझा कर रहे हैं',
              hinglish: 'Hazaaron bhakton se judein jo social media par apne Manauna Dham experiences share kar rahe hain',
            })}
          </p>
        </div>

        <div className="grid sm:grid-cols-3 gap-6 max-w-3xl mx-auto">
          {communities.map((c) => (
            <a
              key={c.tag}
              href={c.url}
              target="_blank"
              rel="noopener noreferrer"
              className={`group relative rounded-2xl ${c.bgLight} border ${c.borderColor} p-6 text-center transition-all duration-300 hover:shadow-xl hover:-translate-y-1 overflow-hidden`}
            >
              <div className={`absolute inset-0 bg-gradient-to-br ${c.color} opacity-0 group-hover:opacity-5 transition-opacity duration-300`} />
              <div className="relative">
                <div className={`mx-auto w-14 h-14 rounded-2xl bg-gradient-to-br ${c.color} flex items-center justify-center mb-4 shadow-lg group-hover:scale-110 transition-transform duration-300`}>
                  <Instagram className="h-7 w-7 text-white" />
                </div>
                <div className={`text-lg font-bold ${c.textColor} flex items-center justify-center gap-1`}>
                  <Hash className="h-4 w-4" />
                  {c.tag.slice(1)}
                </div>
                <div className="mt-2 text-sm text-secondary-500 font-medium">
                  {c.posts} {t({ en: 'posts', hi: 'पोस्ट', hinglish: 'posts' })}
                </div>
                <div className="mt-3 inline-flex items-center gap-1 text-xs font-semibold text-secondary-400 group-hover:text-secondary-600 transition-colors">
                  {t({ en: 'Explore on Instagram', hi: 'Instagram पर देखें', hinglish: 'Instagram pe dekho' })}
                  <ExternalLink className="h-3 w-3" />
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  )
}
